import { ReactNode } from 'react';

// Design System
import Link from 'jl-design-system/elements/link/Link';

// Types
import { ErrorProps } from 'types/Error.types';

// Config
import errorMessageBodyLookup from '../error/errorMessageBodyLookup';
import appConstants from '../../constants/appConstants';
import errorCodeConstants from '../../constants/errorCodeConstants';

export const is3DSSubmissionError = (submitOrderError: ErrorProps): boolean => [
  errorCodeConstants.CLIENT_PAYMENT_3DS_CANCELLED_ERROR,
  errorCodeConstants.CLIENT_PAYMENT_OCP_3DS_INVALID_ERROR,
].includes(submitOrderError.bodyLookup ?? '');

export const getSubmitOrderErrorMessageTitle = (
  submitOrderError: ErrorProps, showPartnerCardError: boolean,
): string => {
  if (is3DSSubmissionError(submitOrderError) && showPartnerCardError) {
    return 'Your Partnership Card security check was not completed';
  }

  return submitOrderError.message ?? '';
};

export const renderEnhancedCallCentreMessage = (): ReactNode => {
  const callCentreNumberEnhanced = appConstants.CALL_CENTRE_NUMBERS.enhanced;

  return (
    <p>
      If the problem persists, please contact the John Lewis customer service team on <a href={`tel:${callCentreNumberEnhanced.replace(/\s+/g, '')}`}>{callCentreNumberEnhanced}</a> to place your order.
    </p>
  );
};

export const getSubmitOrderErrorMessageBody = ({
  showCallCentreNumberOn3DSError,
  showPartnerCardError,
  submitOrderError,
}: {
  showCallCentreNumberOn3DSError: boolean; showPartnerCardError: boolean; submitOrderError: ErrorProps;
}): string | ReactNode => {
  if (is3DSSubmissionError(submitOrderError) && showPartnerCardError) {
    const callCentreNumber = appConstants.CALL_CENTRE_NUMBERS.partnership;

    return (
      <>
        <p>
          Sorry, we couldn&apos;t place your order because you didn&apos;t complete your bank&apos;s security check.
          No payment has been taken.
        </p>
        <p>You can try to complete your payment again with this card.</p>
        { showCallCentreNumberOn3DSError && renderEnhancedCallCentreMessage() }

        {!showCallCentreNumberOn3DSError && (
          <>
            <p>
              If you&apos;ve had problems with the SMS/text message or were unable to confirm the payment
              within the app, please call John Lewis on <a href={`tel:${callCentreNumber.replace(/\s+/g, '')}`}>{callCentreNumber}</a>.
              Our lines are open Monday to Friday 8am to 8pm, Saturday 9am to 6pm and Sunday 10am to 4pm.
            </p>
            <p>For more information about making payments online, visit{' '}
              <Link
                external
                target="_blank"
                to="//johnlewisfinance.com/secureshopping"
              >
                johnlewisfinance.com/secureshopping
              </Link>
            </p>
          </>
        )}
      </>
    );
  }

  if (is3DSSubmissionError(submitOrderError) && showCallCentreNumberOn3DSError) {
    return (
      <>
        <p>
          Sorry, we couldn&apos;t place your order because you didn&apos;t complete your bank&apos;s security check.
          No payment has been taken. Please try again or try another payment method.
        </p>
        { renderEnhancedCallCentreMessage() }
      </>
    );
  }

  return errorMessageBodyLookup({
    bodyLookup: submitOrderError.bodyLookup,
    body: submitOrderError.body,
  });
};
